import {Container} from "pixi.js";

export class FrmCalcPoint {
    x: number;
    y: number;
    graphic: Container

    name: string;

    constructor(name: string, x: number, y: number, graphic: Container) {
        this.name = name;
        this.x = x;
        this.y = y;
        this.graphic = graphic;
    }

    // don't forget to call point ref-adjustment update
    set(x: number, y: number) {
        if(x === this.x && y === this.y) return;

        this.x = x;
        this.y = y;
    }
}
